import { Client } from '@models/client.model';

import { mockClients } from '../../../mockData/clients';

export const getClients = async (): Promise<Client[]> => {
  return Promise.resolve(mockClients);
};

export const getClient = async (index: number): Promise<Client | undefined> => {
  return Promise.resolve(mockClients[0]);
};
